import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 91716 166087"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#1c1b17;stroke-width:2382.98}.fil0{fill:#1c1b17}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970061592528">
        <path
          d="M90525 128181V74835l-44667 36372L1191 74835v53346l44667 36369z"
          className="fill stroke1"
          style={{
            strokeWidth: 2382.98,
          }}
        />
        <path
          d="M90525 55898V38488L45858 74859 1191 38488v17410l44667 36373z"
          className="fill stroke1"
          style={{
            strokeWidth: 2382.98,
          }}
        />
        <path
          d="M90525 19919V2507L45858 38878 1191 2507v17412l44667 36372z"
          className="fill stroke1"
          style={{
            strokeWidth: 2382.98,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
